import { requiredAssetsToAssetMap } from '@/lib/utils/assetMap';

interface LogoAsset {
    src?: string;
    [key: string]: unknown;
}

const logos = (): Record<string, LogoAsset> =>
    // @ts-expect-error require.context is not defined in types
    requiredAssetsToAssetMap(require.context('@/static/logo/32x32', false, /\.svg$/)) as Record<string, LogoAsset>;

export default logos;
